import get from 'lodash/get';
import { DESIGNER_PRO } from 'common/constants/designerModes';
import { APP } from '../index';

export const getUser = (state) => get(state, `${APP}.user.data`, {});

export const getUserId = (state) => getUser(state).id;

export const isUser = (state) => !!Object.keys(getUser(state)).length;

export const getIsUserLoading = (state) => state[APP].user && state[APP].user.loading;

export const getIsUserFreemium = (state) => !getUser(state).organizationId;

export const getIsUserAdmin = (state) => !!getUser(state).admin; // Checks if user is a spladmin

export const getIsUserInDesignerPro = (state) => getUser(state).designerMode === DESIGNER_PRO;

export const getUserOrgId = (state) => get(getUser(state), 'organizationId');

export const getUserOrgName = (state) => get(getUser(state), 'organization.name');

export const getIsUserOrgAdmin = (state) => !!getUser(state).orgAdmin; // Check if a user is an org admin

export const getIsUserEnterpriseOrPro = (state) =>
    ['enterprise', 'professional', 'internal', 'demo'].includes(getUser(state).organization?.teamPackageCode);
